// React and React Router Imports
import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';

// Icons Imports
import { AddCircle, Edit, NotificationBing, Send2, Trash } from 'iconsax-react';

// MUI Imports
import {
    Box,
    Grid2,
    Chip,
    Stack,
    Dialog,
    Button,
    Tooltip,
    TextField,
    Typography,
    InputLabel,
    DialogTitle,
    FormControl,
    Autocomplete,
    DialogActions,
    DialogContent,
    CircularProgress,
    DialogContentText,
    SelectChangeEvent,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

// Custom Hooks Imports
import { dispatch } from 'store';
import useAuth from 'hooks/useAuth';
import useContemp from 'hooks/useContemp';

// Components Imports
import Snackbar from 'utils/Snackbar';
import MainCard from 'components/MainCard';
import ModalFilter from 'components/ModalFilters2';
import SkeletonTable from 'components/SkeletonTable';
import NotFound from 'pages/course/wishlist/NotFound';
import IconButton from 'components/@extended/IconButton';
import CustomTable from 'components/@extended/CustomTable';
import RequiredIndicator from 'components/@extended/RequiredIndicator';

// Redux Imports
import {
    setNotificationList,
    setNotificationListPageIndex,
    setNotificationListPageSize,
} from 'store/reducers/notification';
import { useSelector } from 'react-redux';

// APIs Services Tmports
import { getAllUser, getFilterListUser } from 'services/user.service';
import { addCustomNotification } from 'services/notifyMessage.service';
import { deleteNotification, getAllNotification } from 'services/notification.service';

// Other Library Imports
import * as yup from 'yup';
import moment from 'moment';
import { useFormik } from 'formik';

function EmailTemplateList() {

    const theme = useTheme();
    const navigate = useNavigate();
    const { user }: any = useAuth();
    const { pathname } = useLocation();

    const mode = theme.palette.mode;

    const { setData, prevStoredData } = useContemp();

    const [templateId, setTemplateId] = useState('');
    const [notFound, setNotFound] = useState(true);
    const [disabled, setDisabled] = useState(false);
    // const [active, setActive] = useState<any>(false);
    const [isLoading, setIsLoading] = useState(true);
    const [open, setOpen] = useState<boolean>(false);
    const [userList, setUserList] = useState<any>([]);
    const [cretedByData, setCreatedByData] = useState([]);
    const [submitFilters, setSubmitFilters] = useState(false);
    const [disabledFilter, setDisabledFilter] = useState(true);
    const [sendEmailLoader, setSendEmailLoader] = useState(false);
    const [notificationId, setnotificationId] = useState<string>('');
    const [filterValues, setFilterValues] = useState<any>(
        prevStoredData?.[pathname]?.filters
        ? prevStoredData?.[pathname]?.filters
        : {
                search: '',
                FilterTypes: [],
                active: [],
                createdBy: { ids: [], names: [], indices: [] },
                startDate: null,
                endDate: null
            }
            );
    const [filterSubmitValues, setFilterSubmitValues] = useState<any>({
        search: '',
        FilterTypes: [],
        active: [],
        createdBy: { ids: [], names: [], indices: [] },
        startDate: null,
        endDate: null
    });
    const [openSendEmailDialog, setOpenSendEmailDialog] = useState<boolean>(false);

    const options = ['createdBy'];

    const [totalFilter, setTotalFilter] = useState<any>({
        search: '',
        FilterTypes: { val1: options, val2: 'checkbox', val3: {} }
    });

    const search = useSelector((state: any) => state?.notification)?.NotificationList?.search;
    const pageIndex = useSelector((state: any) => state?.notification)?.NotificationList?.pageIndex;
    const pageSize = useSelector((state: any) => state?.notification)?.NotificationList?.pageSize;
    const notification = useSelector((state: any) => state?.notification)?.NotificationList?.notification;
    const count = useSelector((state: any) => state?.notification)?.NotificationList?.count || 0;

    const userTypeOptions = user.type === "superadmin"
        ? [{ label: 'Admin', value: 'admin' }]
        : [
            { label: 'Admin', value: 'admin' },
            { label: 'Faculty', value: 'faculty' },
            { label: 'Student', value: 'student' },
        ]

    const activeStatus = ['true', 'false'];
    const createdById = [...new Set(cretedByData?.map((item: any) => item._id))];
    const createdByName = [...new Set(cretedByData?.map((item: any) => item.firstName))];


    function capitalizeFirstLetter(str: any) {
        return str
            .split(' ')
            .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
    }

    const getNotification = async () => {
        // setIsLoading(true);

        let reqData: any = {
            eventName: 'custom',
            search: search,
            skip: pageIndex,
            limit: pageSize
        };

        if (user.type !== "superadmin") {
            reqData.orgId = user?.activeOrganizationId || user?.organizationId?._id
        }

        if (filterValues.search) reqData.search = filterValues.search;
        if (filterValues?.startDate) reqData.startDate = filterValues.startDate;
        if (filterValues?.startDate) reqData.endDate = filterValues.endDate ? filterValues.endDate : new Date();
        if (filterValues?.active) reqData.active = filterValues?.active;
        if (filterValues?.createdBy?.ids?.length > 0) reqData.createdBy = filterValues?.createdBy?.ids;
        getAllNotification(reqData)
            .then((res) => {
                if (res.status === 200) {
                    setDisabledFilter(false);
                    // setTemplateList(res.data?.data?.eventNotificationData);
                    dispatch(setNotificationList(res.data.data));
                    // setCount(res.data?.data?.count)
                    setIsLoading(false);
                }
                if (res.data.data?.eventNotificationData?.length > 0) setNotFound(false);
            })
            .catch((err) => {
                if (err?.response?.status === 403) {
                    const errorMessage = err?.response?.data?.message || "You don't have the required permissions to perform this action.";
                    Snackbar(errorMessage, 'warning');
                } else {
                    const errorMessage = err?.response?.data?.message || 'An unexpected error occurred. Please try again later.';
                    Snackbar(errorMessage, 'error');
                }
            });
    };
    useEffect(() => {
        getNotification();
    }, [search, pageSize, pageIndex, submitFilters]);

    const openDialogBox = (id: string) => {
        setOpen(true);
        setnotificationId(id);

    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (event: SelectChangeEvent<number>) => {
        dispatch(setNotificationListPageSize(+event.target.value));
        dispatch(setNotificationListPageIndex(1));
    };

    const deleteNotificationReq = async (notificationId: string) => {
        setDisabled(true);
        await deleteNotification({ notificationId })
            .then((result) => {
                if (result.status === 200) {
                    Snackbar('Email template deleted successfully', 'success');
                    getNotification()
                } else {
                    Snackbar(result.data.message, 'error');
                }
                setDisabled(false);
            })
            .catch((err) => {
                if (err?.response?.status === 403) {
                    const errorMessage = err?.response?.data?.message || "You don't have the required permissions to perform this action.";
                    Snackbar(errorMessage, 'warning');
                } else {
                    const errorMessage = err?.response?.data?.message || 'An unexpected error occurred. Please try again later.';
                    Snackbar(errorMessage, 'error');
                }
                setDisabled(false);
            });
        setOpen(false);
    };

    const handlePageChange = (event: any, page: number) => {
        dispatch(setNotificationListPageIndex(page));
    };

    const Columns = [
        {
            Header: 'Name',
            accessor: 'name'
        },
        {
            Header: 'events',
            accessor: 'eventName'
        },
        {
            Header: 'Action',

            Cell: ({ row }: any) => (
                <Stack display={'flex'} flexDirection={'row'}>
                    <IconButton
                        color="primary"
                        onClick={() => {
                            setOpenSendEmailDialog(true)
                            setTemplateId(row?.original?._id)
                        }}
                    >
                        <Send2 />
                    </IconButton>
                    <IconButton
                        color="primary"
                        onClick={() => {
                            localStorage.setItem('notificationTabIndex', "1")
                            navigate('/notification/email-template-form', { state: { rowData: row.original } });
                            setData({
                                [pathname]: { pageSize, pageIndex, filters: filterValues, gotoUrl: '/notification/email-template-form' }
                            });
                        }}
                    >
                        <Edit />
                    </IconButton>
                    {/* </Link> */}
                    <IconButton
                        color="error"
                        onClick={() => {
                            openDialogBox(row.original._id);
                        }}
                    >
                        <Trash />
                    </IconButton>
                </Stack>
            )
        }
    ];

    const formik = useFormik({
        initialValues: {
            userTypes: [],
            users: []
        },
        validationSchema: yup.object({
            userTypes: yup.array().optional(),
            users: yup.array().optional(),
        }),
        onSubmit: (values: any, { resetForm }: any) => {
            try {
                setSendEmailLoader(true)
                const reqData = {
                    userTypes: values.userTypes.length > 0 ? values.userTypes.map((item: any) => item.value) : [],
                    users: values.users.length > 0 ? values.users.map((item: any) => item._id) : [],
                    templateId,
                    type: "email"
                }

                addCustomNotification(reqData)
                    .then((response: any) => {
                        if (response.status === 200) {
                            Snackbar('Mail sent successfully', 'success');
                            setSendEmailLoader(false)
                            setOpenSendEmailDialog(false)
                            resetForm()
                        } else {
                            setSendEmailLoader(false)
                            Snackbar(response?.data?.message || "Something went wrong!", 'error');
                        }
                    })
                    .catch((err: any) => {
                        setSendEmailLoader(false)
                        if (err?.response?.status === 403) {
                            const errorMessage = err?.response?.data?.message || "You don't have the required permissions to perform this action.";
                            Snackbar(errorMessage, 'warning');
                        } else {
                            const errorMessage = err?.response?.data?.message || 'An unexpected error occurred. Please try again later.';
                            Snackbar(errorMessage, 'error');
                        }
                        // setIsButtonDisabled(false);
                    });
            } catch (e) {
                setSendEmailLoader(false)
                console.log(e);
            }
        }
    });

    const setModalFilters = (key: string, value: any, isFromDelete?: boolean) => {
        if (key === 'FilterTypes') {
            setFilterValues((prev: any) => {
                const currentValue = prev[key] || [];
                let updatedArray;

                if (currentValue.includes(options[value])) {
                    updatedArray = currentValue.filter((item: any) => item !== options[value]);
                } else {
                    updatedArray = [...currentValue, options[value]];
                }

                if (isFromDelete) {
                    setFilterSubmitValues({
                        ...prev,
                        [key]: updatedArray,
                        active: key === 'FilterTypes' && updatedArray.includes('active') ? prev.active : '',
                        createdBy: key === 'FilterTypes' && updatedArray.includes('createdBy') ? prev.createdBy : { ids: [], names: [], indices: [] }
                    });
                }

                return {
                    ...prev,
                    [key]: updatedArray,
                    active: key === 'FilterTypes' && updatedArray.includes('active') ? prev.active : '',
                    createdBy: key === 'FilterTypes' && updatedArray.includes('createdBy') ? prev.createdBy : { ids: [], names: [], indices: [] }
                };
            });
        } else if (key === 'createdBy') {
            setFilterValues((prev: any) => {
                const currentIds = prev[key]?.ids || [];
                const currentNames = prev[key]?.names || [];
                const currentIndices = prev[key]?.indices || [];
                let updatedIds;
                let updatedNames;
                let updatedIndices;

                if (currentIds.includes(createdById[value]) || currentNames.includes(createdByName[value]) || currentIndices.includes(value)) {
                    updatedIds = currentIds.filter((item: any) => item !== createdById[value]);
                    updatedNames = currentNames.filter((item: any) => item !== createdByName[value]);
                    updatedIndices = currentIndices.filter((item: any) => item !== value);
                } else {
                    updatedIds = [...currentIds, createdById[value]];
                    updatedNames = [...currentNames, createdByName[value]];
                    updatedIndices = [...currentIndices, value];
                }

                if (isFromDelete) {
                    setFilterSubmitValues({
                        ...prev,
                        [key]: { ids: updatedIds, names: updatedNames, indices: updatedIndices }
                    });
                }
                return {
                    ...prev,
                    [key]: { ids: updatedIds, names: updatedNames, indices: updatedIndices }
                };
            });
        } else if (key === 'active') {
            setFilterValues((prev: any) => {
                const updatedStatus = activeStatus[value];

                if (isFromDelete) {
                    setFilterSubmitValues({
                        ...prev,
                        [key]: updatedStatus
                    });
                }
                return {
                    ...prev,
                    [key]: updatedStatus
                };
            });
        } else {
            if (isFromDelete) {
                setFilterSubmitValues((prev: any) => ({ ...prev, [key]: value }));
            }
            setFilterValues((prev: any) => ({ ...prev, [key]: value }));
        }
    };

    const loadMoreUser = () => {
        let query: any = {
            list: true,
            type: formik.values.userTypes.length > 0 && formik.values.userTypes?.map((item: any) => item.value)
        };
        if (user.type !== "superadmin") {
            query.orgId = user?.activeOrganizationId || user?.organizationId?._id
        }
        getAllUser(query)
            .then((result) => {
                setUserList(result.data.data);
            })
            .catch((err: any) => {
                console.log(err);
            });
    };

    useEffect(() => {
        if (filterValues.FilterTypes.includes('createdBy')) {
            setTotalFilter((prev: any) => ({ ...prev, createdBy: { val1: createdByName, val2: 'checkbox', val3: createdById } }));
        } else {
            setTotalFilter((prev: any) => {
                const { createdBy: classKey, ...rest } = prev;
                return rest;
            });
        }
        if (filterValues.FilterTypes.includes('active')) {
            setTotalFilter((prev: any) => ({ ...prev, active: { val1: ['true', 'false'], val2: 'radioButton' } }));
        } else {
            setTotalFilter((prev: any) => {
                const { active: classKey, ...rest } = prev;
                return rest;
            });
        }
    }, [filterValues]);

    useEffect(() => {
        const query: any = {}
        if (user.type !== "superadmin") {
            query.orgId = user?.activeOrganizationId || user?.organizationId?._id
        }
        getFilterListUser(query).then((res) => {
            if (res.status === 200) {
                setCreatedByData(res?.data?.data);
            }
        });
    }, []);

    useEffect(() => {
        loadMoreUser()
    }, [formik.values.userTypes]);

    return (
        <>
            <Dialog open={open} onClose={handleClose}>
                <Box sx={{ p: 1, pb: 1.2, textAlign: 'center' }}>
                    <DialogTitle sx={{ fontSize: '20px' }}>
                        <b>< FormattedMessage id="Delete Notification" /></b>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">< FormattedMessage id="Are you sure you want to delete this Notification" /></DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{ justifyContent: 'center' }}>
                        <Button
                            sx={{
                                fontSize: { xs: "12px", sm: "14px", },
                                padding: { xs: "4px 8px", sm: "6px 12px", },
                            }}
                            variant="contained"
                            onClick={handleClose}
                        >
                            < FormattedMessage id="Cancel" />

                        </Button>
                        <Button
                            sx={{
                                fontSize: { xs: "12px", sm: "14px", },
                                padding: { xs: "3.5px 10px", sm: "4.5px 10px", },
                                ":hover": {
                                    color: "white",
                                    backgroundColor: "#dc2626"
                                },
                            }}
                            variant="outlined"
                            color="error"
                            onClick={() => {
                                handleClose();
                                deleteNotificationReq(notificationId);
                            }}
                            autoFocus
                        >
                            < FormattedMessage id="Delete" />


                        </Button>
                    </DialogActions>
                </Box>
            </Dialog>
            <Dialog open={openSendEmailDialog} fullWidth sx={{ minHeight: '500px' }}>
                <form onSubmit={formik.handleSubmit}>
                    <DialogTitle sx={{ fontSize: '20px' }}>
                        <b><FormattedMessage id="Send Email" /></b>
                    </DialogTitle>
                    <DialogContent dividers>
                        <Grid2 container spacing={1} padding={1}>
                            <Grid2 size={12}>
                                <Stack spacing={1} >
                                    <InputLabel sx={{ textAlign: "justify" }}>
                                        <FormattedMessage id="Select User Type" />
                                        <RequiredIndicator />
                                    </InputLabel>
                                    <FormControl sx={{ m: 1, minWidth: 120 }}>
                                        <Autocomplete
                                            multiple
                                            id="userTypes"
                                            disableCloseOnSelect
                                            options={userTypeOptions}
                                            getOptionLabel={(option) => option.label}
                                            value={formik.values.userTypes}
                                            onChange={(_, newValue: any) => {
                                                formik.setFieldValue('userTypes', newValue)
                                            }}
                                            isOptionEqualToValue={(option, value) => option.value === value.value}
                                            renderOption={(props, option, { selected }) => (
                                                <li {...props} >
                                                    {option.label}
                                                </li>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Select user type"
                                                    size="medium"
                                                />
                                            )}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    padding: '3px 9px'
                                                }
                                            }}
                                        />
                                    </FormControl>

                                </Stack>
                            </Grid2>
                            <Grid2 size={12}>
                                <Stack spacing={1} marginBottom={1}>
                                    <InputLabel sx={{ textAlign: "justify" }}>
                                        <FormattedMessage id="Recipient" />
                                        <RequiredIndicator />
                                    </InputLabel>
                                    <FormControl sx={{ m: 1, minWidth: 120 }}>
                                        <Autocomplete
                                            fullWidth

                                            disableCloseOnSelect
                                            value={formik.values.users}
                                            onChange={(_, newValue) => {
                                                formik.setFieldValue('users', newValue);
                                            }}
                                            multiple
                                            id="users"
                                            options={userList || []}
                                            getOptionLabel={(option: any) => {
                                                if (typeof option === 'string') {
                                                    return option;
                                                }
                                                return option?.firstName ? option?.firstName + ' ' + option?.lastName : '';
                                            }}
                                            renderOption={(props, option: any) =>
                                                <li {...props} value={option?._id}>
                                                    {`${option?.firstName} ${option?.lastName} (${capitalizeFirstLetter(option?.type)})`}
                                                </li>
                                            }
                                            renderInput={(params: any) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Select users"
                                                    size="small"
                                                    sx={{
                                                        '& .MuiAutocomplete-input.Mui-disabled': {
                                                            WebkitTextFillColor: theme.palette.text.primary
                                                        }
                                                    }}
                                                />
                                            )}
                                            sx={{
                                                marginBottom:1,
                                                maxHeight: "20px",
                                                '& .MuiInputBase-root': {
                                                    p: '6px 9px !important'
                                                }
                                            }}
                                        />
                                    </FormControl>
                                </Stack>
                            </Grid2>
                        </Grid2>
                    </DialogContent>
                    <DialogActions sx={{ justifyContent: 'right' }}>
                        {sendEmailLoader ? <CircularProgress size={30} sx={{ marginRight: 1 }} /> :
                            <Button
                                sx={{
                                    fontSize: { xs: "12px", sm: "14px", },
                                    padding: { xs: "4px 8px", sm: "6px 12px", },
                                }}
                                type='submit'
                                variant="contained"
                                disabled={sendEmailLoader}
                                autoFocus
                            >
                                <FormattedMessage id="Send" />
                            </Button>
                        }
                        <Button
                            sx={{
                                fontSize: { xs: "12px", sm: "14px", },
                                padding: { xs: "3.5px 10px", sm: "4.5px 10px", },
                                ":hover": {
                                    color: "white",
                                    backgroundColor: "#dc2626"
                                },
                            }}
                            variant="outlined"
                            color="error"
                            onClick={() => {
                                setOpenSendEmailDialog(false)
                                setTemplateId('')
                                formik.resetForm()
                            }}
                        >
                            <FormattedMessage id="Cancel" />
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Box display={'flex'} flexDirection={'column'} justifyContent={'space-between'} gap={'5px'}>
 
            <MainCard
                title={
                    <span style={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography variant="h5">
                            <FormattedMessage id="Email Template List" />
                        </Typography>
                        <Typography variant="body2">
                            <FormattedMessage id="Manage email templates with options to send, add, edit, or delete." />
                        </Typography>
                    </span>
                }
                content={false}
                sx={{
                    '& .MuiCardHeader-root': {
                      padding: '7px 13px'
                    }
                  }}
                secondary={
                    <Stack display={'flex'} flexDirection={'row-reverse'} justifyContent={'space-between'} sx={{ my: 1 }}>
                        <Tooltip title={<FormattedMessage id="Add Notification" />}>
                            <span>
                                <IconButton
                                    variant="dashed"
                                    color="primary"
                                    onClick={() => {
                                        navigate('/notification/email-template-form');
                                    }}
                                >
                                    <AddCircle />
                                </IconButton>
                            </span>
                        </Tooltip>
                        <Stack sx={{ mt: 1 }}>
                            <Tooltip title={<FormattedMessage id="Filter" />}>
                                <span>
                                    <ModalFilter
                                        filterKeywords={totalFilter}
                                        onFilterKeywordChange={setModalFilters}
                                        count={count}
                                        values={filterValues}
                                        applyFilter={setSubmitFilters}
                                        filterFlag={submitFilters}
                                        filterValuesSet={setFilterValues}
                                        setFilterSubmitValues={setFilterSubmitValues}
                                        submittedFilterValues={filterSubmitValues}
                                        // disabled={disabledFilter}
                                        setDisabled={setDisabledFilter}
                                        pageIndex={setNotificationListPageIndex}
                                    />
                                </span>
                            </Tooltip>
                        </Stack>
                    </Stack>
                }
            >
                </MainCard>
                <MainCard content = {false}>
                {isLoading ? (
                    <SkeletonTable columns={Columns} />
                ) : (
                    <>
                        <Box
                            sx={{
                                height: '100%',
                                overflow: 'hidden',
                                // boxShadow: theme.shadows[2],
                                filter: disabled ? 'grayscale(100%) blur(3px)' : 'none'
                            }}
                        >
                            <Stack display={'flex'} sx={{ m: 1 }} flexDirection={'row'} flexWrap={'wrap'}>
                                {filterValues?.createdBy?.ids?.length > 0 || filterValues?.search || filterValues?.startDate ? (
                                    <Button
                                        variant="outlined"
                                        onClick={() => {
                                            setSubmitFilters(!submitFilters);
                                            setFilterValues({ search: '', FilterTypes: [], isActive: [], createdBy: [], startDate: null, endDate: null });
                                            setFilterSubmitValues({ search: '', FilterTypes: [], isActive: [], createdBy: [], startDate: null, endDate: null });
                                        }}
                                        sx={{ m: 1 }}
                                    >
                                        Clear All
                                    </Button>
                                ) : (
                                    <></>
                                )}
                                {Object.entries<any>(filterValues).map(([key, values]: [string, string[] | string]) =>
                                    (Array.isArray(values) ? values : [values]).map(
                                        (value: any, index: number) =>
                                            value &&
                                            value !== undefined &&
                                            value !== null && (
                                                <div key={`${key}-box`}>
                                                    {key === 'active'
                                                        ? values &&
                                                        values.length > 0 && (
                                                            <div
                                                                key={`${key}-box`}
                                                                style={{
                                                                    border: '1px solid gray',
                                                                    display: 'flex',
                                                                    margin: '2px',
                                                                    borderRadius: '15px',
                                                                    flexDirection: 'row'
                                                                }}
                                                            >
                                                                <Typography mx={1} mt={1.5}>
                                                                    {' '}
                                                                    <b>{capitalizeFirstLetter(key)}:</b>{' '}
                                                                </Typography>
                                                                {(Array.isArray(values) ? values : [values]).map(
                                                                    (value: string | Number, index: number) =>
                                                                        value !== undefined &&
                                                                        value !== null && (
                                                                            <Chip
                                                                                key={`${key}-${index}`}
                                                                                sx={{ m: 1 }}
                                                                                label={`${value}`}
                                                                                color={key === 'active' ? 'primary' : 'secondary'}
                                                                                style={{ color: key !== 'active' && mode === 'dark' ? 'black' : 'white' }}
                                                                                onDelete={() => {
                                                                                    if (key === 'active' || key === 'createdBy' || key === 'search') {
                                                                                        setSubmitFilters(!submitFilters);
                                                                                        setModalFilters(key, value, true);
                                                                                    } else {
                                                                                        setModalFilters(key, '');
                                                                                    }
                                                                                }}
                                                                            />
                                                                        )
                                                                )}
                                                            </div>
                                                        )
                                                        : value?.names?.length !== 0 && (
                                                            <>
                                                                {value?.names ? (
                                                                    <div
                                                                        key={`${key}-${index}`}
                                                                        style={{
                                                                            border: '1px solid gray',
                                                                            margin: '2px',
                                                                            borderRadius: '15px',
                                                                            display: 'flex',
                                                                            flexDirection: 'row',
                                                                            backgroundColor: key === 'createdBy' && mode !== 'dark' ? '#F8F9FA' : 'transparent'
                                                                        }}
                                                                    >
                                                                        <Typography mx={1} mt={1.5}>
                                                                            {' '}
                                                                            <b>{capitalizeFirstLetter(key)}:</b>{' '}
                                                                        </Typography>
                                                                        {value?.names?.map((name: string, nameIndex: number) => (
                                                                            <Chip
                                                                                key={`${key}-${index}-${nameIndex}`}
                                                                                sx={{ my: 1, mx: 0.3 }}
                                                                                label={name}
                                                                                color={key === 'createdBy' ? 'primary' : 'secondary'}
                                                                                style={{ color: key !== 'createdBy' && mode === 'dark' ? 'black' : 'white' }}
                                                                                onDelete={() => {
                                                                                    setSubmitFilters(!submitFilters);
                                                                                    if (key === 'FilterTypes' || key === 'createdBy') {
                                                                                        setModalFilters(key, value?.indices?.[nameIndex]);
                                                                                    } else {
                                                                                        setModalFilters(key, '');
                                                                                    }
                                                                                }}
                                                                            />
                                                                        ))}
                                                                    </div>
                                                                ) : (
                                                                    <></>
                                                                )}
                                                            </>
                                                        )}
                                                </div>
                                            )
                                    )
                                )}

                                {filterValues.startDate || filterValues.endDate ? (
                                    <div
                                        style={{
                                            border: '1px solid gray',
                                            margin: '2px',
                                            borderRadius: '15px',
                                            display: 'flex',
                                            flexDirection: 'row'
                                        }}
                                    >
                                        <React.Fragment>
                                            <Typography mx={1} mt={1.5}>
                                                <b>Range:</b>
                                            </Typography>
                                            <Chip
                                                label={`${moment(filterValues.startDate).format('DD-MM-YYYY')} to ${moment(
                                                    filterValues.endDate || new Date()
                                                ).format('DD-MM-YYYY')}`}
                                                color="primary"
                                                sx={{ m: 1 }}
                                                onDelete={() => {
                                                    setSubmitFilters(!submitFilters);
                                                    setModalFilters('startDate', null);
                                                    setModalFilters('endDate', null);
                                                }}
                                            />
                                        </React.Fragment>
                                    </div>
                                ) : null}

                                {filterValues.search ? (
                                    <div
                                        style={{
                                            border: '1px solid gray',
                                            margin: '2px',
                                            borderRadius: '15px',
                                            display: 'flex',
                                            flexDirection: 'row'
                                        }}
                                    >
                                        <React.Fragment>
                                            <Typography mx={1} mt={1.5}>
                                                <b>Search:</b>
                                            </Typography>
                                            <Chip
                                                label={filterValues.search}
                                                color="primary"
                                                sx={{ m: 1 }}
                                                onDelete={() => {
                                                    setSubmitFilters(!submitFilters);
                                                    setModalFilters('search', '');
                                                }}
                                            />
                                        </React.Fragment>
                                    </div>
                                ) : null}
                            </Stack>

                            {notification?.length > 0 ? (
                                <CustomTable
                                    icon={NotificationBing}
                                    text={<FormattedMessage id="No notification to display" />}
                                    link="/notification/email-template-form"
                                    sortArray={[]}
                                    columns={Columns}
                                    data={notification}
                                    sort={[]}
                                    setSortingData={null}
                                    notFound={notFound}
                                    search={search}
                                    count={count}
                                    size={pageSize}
                                    pageIndex={pageIndex}
                                    handlePageChange={handlePageChange}
                                    handleSizeChange={handleChange}
                                />
                            ) : (
                                <NotFound
                                    icon={NotificationBing}
                                    text={<FormattedMessage id="No notification data available, Add notification now !" />}
                                    link={'/notification/email-template-form'}
                                />
                            )}
                        </Box>
                    </>
                )}
            </MainCard>
            </Box>
        </>
    );
}

export default EmailTemplateList;
